// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2c8J8","productName":"Table_productName__1Bhou"};